const fn = {

    init: () => {
        const paginationToggle = document.querySelectorAll('.pagination-toggle')
        paginationToggle.forEach(element => {

            element.addEventListener('click', fn.handlePaginationToggle)
            const form = document.querySelector('.dropdown-pagination')

            const pageCount = parseInt(form.querySelector('input[name="pageCount"]').value)
            const totalPages = parseInt(form.querySelector('.totalPages').innerText)
            if (element.classList.contains('pagination-prev')) {
                if (pageCount == 1) {
                    element.classList.add('opacity-50')
                    element.classList.remove('hover:opacity-90')
                }
            }
            if (element.classList.contains('pagination-next')) {
                if (pageCount == totalPages) {
                    element.classList.add('opacity-50')
                    element.classList.remove('hover:opacity-90')
                }
            }

        })
    },

    handlePaginationToggle: (e) => {
        e.preventDefault()
        const button = e.target.closest('button')
        const form = button.closest('form')
        const pageCount = parseInt(form.querySelector('input[name="pageCount"]').value)
        const totalPages = parseInt(form.querySelector('.totalPages').innerText)
        if (button.classList.contains('pagination-prev')) {
            if (pageCount > 1) {
                form.querySelector('input[name="pageCount"]').value = pageCount - 1
                form.submit()
            }
            else {
                button.disabled = true
            }
        }
        if (button.classList.contains('pagination-next')) {
            if (pageCount < totalPages) {
                form.querySelector('input[name="pageCount"]').value = pageCount + 1
                form.submit()
            }
            else {
                button.disabled = true
            }
        }
    },

}

export default {
    can: () => document.querySelectorAll('.pagination-toggle').length > 0,
    run: fn.init,
}
